<template>
  <div id="footer" class="border-b-8 border-green-500 bg-gray-800">
    <div
      class="container mx-auto mt-14 px-8 py-12 text-center text-gray-300 lg:px-16"
    >
      <div
        class="mx-auto max-w-2xl rounded-lg bg-gray-500 p-10 shadow-xl"
        style="margin-top: -100px"
      >
        <p class="text-2xl">
          Intéressé par HerdingCats et la santé de votre chat ?
        </p>
        <p
          class="mt-4 mb-6 flex flex-row items-center text-center lg:text-left"
        >
          <span class="mr-4 inline-block flex-shrink-0">
            <img
              v-if="thanks"
              src="@/assets/img/content.gif"
              class="h-16 w-auto"
              alt
            />
            <img
              v-if="dislike"
              src="@/assets/img/triste.gif"
              class="h-16 w-auto"
              alt
            />
          </span>
          {{ formText }}
        </p>
        <NewsletterForm v-if="!thanks && !dislike" :forceAngle="forceAngle" />
      </div>

      <div class="mt-12 flex w-full flex-col md:flex-row">
        <div>
          <svgLogoHorizontal class="mx-auto mb-4 h-8 md:mx-0" />
          <ul class="flex justify-center md:justify-start">
            <li class="h-8 w-8">
              <a
                href="https://www.instagram.com/herdingcatstech/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svgInstagram
                  class="fill-current text-green-500 hover:text-green-400"
                />
              </a>
            </li>
            <li class="h-8 w-8">
              <a
                href="https://www.facebook.com/herdingcat/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svgFacebook
                  class="fill-current text-green-500 hover:text-green-400"
                />
              </a>
            </li>
            <li class="h-8 w-8">
              <a
                href="https://twitter.com/herdingcats8"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svgTwitter
                  class="fill-current text-green-500 hover:text-green-400"
                />
              </a>
            </li>
            <li class="h-8 w-8">
              <a
                href="https://www.linkedin.com/company/herdingcats/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svgLinkedin
                  class="fill-current text-green-500 hover:text-green-400"
                />
              </a>
            </li>
          </ul>
        </div>
        <p class="mt-4 leading-relaxed md:mt-0 md:ml-auto md:text-right">
          <a href="mailto:contact@herdingcats.fr" class="hover:text-green-500"
            >contact@herdingcats.fr</a
          >
          <br />18 rue Pasteur <br />94270 Le Kremlin Bicêtre France
        </p>
      </div>
    </div>
    <div class="bg-gray-900 text-gray-300">
      <div class="container mx-auto px-8">
        <ul class="flex flex-col p-4 text-center md:flex-row md:text-left">
          <li
            class="mb-2 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mr-4 md:mb-0"
          >
            <a href="#" v-scroll-to="'#application'">L’application</a>
          </li>
          <li
            class="mb-2 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mr-4 md:mb-0"
          >
            <a href="#" v-scroll-to="'#collier'">Le collier</a>
          </li>
          <li
            class="mb-2 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mr-4 md:mb-0"
          >
            <a href="#" v-scroll-to="'#fonctionnement'">Fonctionnement</a>
          </li>
          <!-- <li
            class="mb-2 mr-4 text-sm font-medium tracking-wide uppercase font-raleway md:mb-0 hover:text-white"
          >
            <a href="#" v-scroll-to="'#timeline'">Notre histoire</a>
          </li> -->
          <li
            class="mb-2 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mr-4 md:mb-0"
          >
            <a href="../tech">Tech</a>
          </li>
          <li
            class="mb-2 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mb-0 md:mr-4"
          >
            <a href="../rgpd">RGPD</a>
          </li>
          <li
            class="mb-2 flex-1 font-raleway text-sm font-medium uppercase tracking-wide hover:text-white md:mb-0"
          >
            <a href="../mentions-legales">Mentions légales</a>
          </li>
          <li
            class="font-raleway text-sm font-medium uppercase tracking-wide hover:text-white"
          >
            <a
              href="https://blackfoot.io/"
              target="_blank"
              rel="noopener noreferrer"
              >© Blackfoot</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import svgLogoHorizontal from "../assets/svg/logoHorizontal.svg";
import svgInstagram from "../assets/svg/instagram.svg";
import svgFacebook from "../assets/svg/facebook.svg";
import svgTwitter from "../assets/svg/twitter.svg";
import svgLinkedin from "../assets/svg/linkedin.svg";
import NewsletterForm from "./NewsletterForm";

export default {
  name: "Footer",
  props: {
    forceAngle: {
      default: null,
      type: String,
    },
    thanks: {
      default: false,
      type: Boolean,
    },
    dislike: {
      default: false,
      type: Boolean,
    },
    // isGpsEnabled: {
    //   default: true,
    //   type: Boolean
    // }
  },
  components: {
    svgLogoHorizontal,
    svgInstagram,
    svgFacebook,
    svgTwitter,
    svgLinkedin,
    NewsletterForm,
  },
  computed: {
    formText: function () {
      if (this.thanks) {
        return "Merci !";
      } else if (this.dislike) {
        return "Merci de votre avis, nous le prenons en compte et espérons que vous allez aimer la prochaine !";
      } else {
        return "Inscrivez vous à la newsletter pour être au courant de notre actualité";
      }
    },
  },
};
</script>
